import WalletMoney from "@assets/icons/wallet-money.svg";
import { Block } from "@components/block";
import { Blured } from "@components/blured";
import { ChartFilter } from "@components/chart-filter";
import { ProfitChart, ProfitFilterType } from "@components/profit-chart";
import { formatUsdt } from "@helpers/format";
import { useState } from "react";
import styles from "./profit.module.scss";

type Props = {
  profit: number;
};

export const Profit = ({ profit }: Props) => {
  const [filter, setFilter] = useState<ProfitFilterType>("week");

  return (
    <Block className={styles.card}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <h3 className={styles.title}>Прибыль</h3>
          <p className={styles.profit}>{formatUsdt(profit)}</p>
        </div>
        <div className={styles.icon}>
          <WalletMoney />
        </div>
      </div>
      <Blured className={styles.chartFilterContainer}>
        <ChartFilter
          type={filter}
          setType={setFilter}
          className={styles.filter}
        />
      </Blured>
      <ProfitChart type={filter} />
    </Block>
  );
};
